import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Button,
  Upload,
  Typography,
  Alert
  } from "antd";
  
  const { Title } = Typography;
  
  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
  };
  
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4,
    },
  };
  
  const AppConfigDetailsForm = ({
    setHeaderBgColor,
    onSubmit,
    file,
    onFileUpload,
    appThemConfigCollection,
    headerBgColor
  }) => {
    const [form] = Form.useForm();

    const onHandleSubmit = () => {
      form.resetFields();
      onSubmit()
    }

    return (
      <div className="election-form">
        {appThemConfigCollection.length >= 1 && (
          <Alert
            message="Hello Admin, You can not add more app config  details because you've already added 1 app config Details,
            If you want to add then please remove it!!!"
            type="info"
            showIcon
          />
        )}
        <Form {...formItemLayout} form={form}>
          <Title level={3} style={{ marginLeft: "10%" }}>
            {false ? "Update" : "Add"} App Config Details
          </Title>
          {/* <Form.Item label="Header Color">
            <Input
              onChange={({ target }) => setHeaderBgColor(target.value)}
              placeholder="Enter App Config Header Color"
              name="headerBgColor"
              disabled={appThemConfigCollection.length >= 1}
              value={headerBgColor}
            />
          </Form.Item> */}
          <Form.Item
            name="appHeaderImage"
            label="App Header Image"
            valuePropName="fileList"
            getValueFromEvent={onFileUpload}
          >
            <Upload
              accept="image/gif, image/jpeg, image/png"
              multiple={false}
              type="select"
              name="thumbnail"
              showUploadList={false}
              disabled={appThemConfigCollection.length >= 1}
            >
              <Button>
                <UploadOutlined /> Click to upload
              </Button>
              {file && <p>{file.name}</p>}
            </Upload>
          </Form.Item>
          <Form.Item {...buttonItemLayout}>
            <Button
              onClick={onHandleSubmit}
              type="primary"
              style={{
                background: "#ff0b53",
                borderColor: "#ff0b53",
                borderRadius: 5,
              }}
              disabled={appThemConfigCollection.length >= 1}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
  
export default AppConfigDetailsForm;
